import { createSlice } from '@reduxjs/toolkit';
import { Groups } from './helpers';

export const INITIAL_STATE = {
  groupExpandStates: Object.keys(Groups)
    .filter(key => Number(key))
    .reduce((groupExpandStates, key) => {
      groupExpandStates[key] = false;

      return groupExpandStates;
    }, {})
};

const slice = createSlice({
  name: 'company-settings',
  initialState: INITIAL_STATE,
  reducers: {
    setGroupExpandStates: (state, { payload }) => {
      const { id, isExpanded } = payload;

      state.groupExpandStates[id] = isExpanded;
    }
  }
});

export const { setGroupExpandStates } = slice.actions;

export default slice.reducer;
